const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAdminById = async (id) => {
    const token = localStorage.getItem("token"); 
    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/user/admin-accounts/${id}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Ошибка при получении данных сотрудника');
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error(`Ошибка при получении сотрудника с ID ${id}:`, error);
        throw error;
    }
};